/**
 * Utility functions for handling tables and datatables.
 */

/**
 * Takes datatable paging, sorting and search params and transforms them into params to request pageable data
 *
 * @param page page to load
 * @param size size of page to load
 * @param search term to search for
 * @param sort array of datatable fields to sort
 * @param sortDesc array of boolean to sort by either desc (true) or asc (false)
 * @param tableFields fields of the table to transform to datatable fields
 * @param databaseFields datatable fields to send to backend
 * @returns {URLSearchParams}
 */
export function createPageableParams(page, size, search, sort, sortDesc, tableFields, databaseFields){
  //create copy of the sort array, or we change the real sort array, causing issues with datatable
  let fixedSort = [...sort];
  //replace the table fields with the database fields for sorting
  for(let i = 0; i < sort.length; i++){
    for(let j = 0; j < tableFields.length; j++){
      if(sort[i] === tableFields[j]){
        fixedSort[i] = databaseFields[j];
        break;
      }
    }
  }
  //create the url parameters
  let params = new URLSearchParams();
  //we can sort multiple fields at the same time, so have to loop over them
  for(let i = 0; i < sort.length; i++){
    params.append("sort",fixedSort[i] + "," + (sortDesc[i] ? 'desc' : 'asc'));
  }
  params.append("page",page);
  params.append("size",!size || size === -1 ? 2147483646 : size); //maximum int value
  params.append("search", search);
  return params;
}
